import { render, staticRenderFns } from "./GeographyCargoTransportationBlock.vue?vue&type=template&id=ccc581de&scoped=true&"
import script from "./GeographyCargoTransportationBlock.vue?vue&type=script&lang=js&"
export * from "./GeographyCargoTransportationBlock.vue?vue&type=script&lang=js&"
import style0 from "./GeographyCargoTransportationBlock.vue?vue&type=style&index=0&id=ccc581de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc581de",
  null
  
)

export default component.exports